export default __webpack_public_path__ + "static/media/laptopBg.9db8475c.jpg";